import { render, staticRenderFns } from "./fechasb.vue?vue&type=template&id=b35d7eb2"
import script from "./fechasb.vue?vue&type=script&lang=js"
export * from "./fechasb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports